import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p432843078304292864',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
